import { render } from "./App.vue?vue&type=template&id=ae78bd2a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=ae78bd2a&lang=scss"

import exportComponent from "/Users/matthew/Documents/Vault/code/sal/malum/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__